import { BrowserRouter, Routes, Route } from 'react-router';
import WebMockPage from '@/features/web-mock/WebMockPage';

/** Hosted SPA: mock shell until a full web experience is productized. */
export default function AppWeb() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="*" element={<WebMockPage />} />
            </Routes>
        </BrowserRouter>
    );
}
